import React from "react";
import ReactDOM from "react-dom";
import DeliveredBalancesTable from "../../../app/components/modals/employee/DeleteEmployeesModal/steps/DeliveredBalances/components/DeliveredBalancesTable";

function renderEmployeesMassiveDeleteDeliveredBalances(props) {
  ReactDOM.render(
    <DeliveredBalancesTable {...props} />,
    document.getElementById("employees-massive-delete-delivered-balances-table")
  );
}

export default function displayEmployeesMassiveDeleteDeliveredBalances(props) {
  renderEmployeesMassiveDeleteDeliveredBalances(props);
}
